import FieldRenderer from "../global/forms/FieldRenderer";
import dataConstants from "../../constants/dataConstants";
import OnlineOrderFormProps from "../../services/models/formModels/OnlineOrderForm.model";

function PersonalInfo({
  touched,
  errors,
  handleChange,
  handleBlur,
  values,
  getFieldMeta,
  setFieldValue,
  disabled
}: OnlineOrderFormProps): JSX.Element {
  return (
    <FieldRenderer
      fields={dataConstants.personalInfoFields.map((field, index) => ({
        key: `${index}${field.labelInfo?.inputId}`,
        ...field,
        getFieldMeta,
        setFieldValue,
        values,
        errors: errors,
        touched: touched,
        onChange: handleChange,
        value: values?.[!!field?.name ? field.name : ""],
        onBlur: handleBlur,
        name: field.name,
        roundedInput: true,
        // 'data-openreplay-obscured':true,
        "data-dd-privacy": "mask",
        disabled: disabled,
        parentContainerClass: ["birthDate", "gender"].includes?.(
          field?.name ? field.name : ""
        )
          ? `md:!w-[48%] ${field.parentContainerClass}`
          : "",
      }))}
    />
  );
}

export default PersonalInfo;
